import api from "@/lib/api";

const KEY = "syllabify_ref";

export function captureRef() {
  const p = new URLSearchParams(window.location.search);
  const ref = p.get("ref");
  if (ref) {
    const code = ref.toUpperCase();
    localStorage.setItem(KEY, code);
    api.post("/referral/click", { ref_code: code }).catch(() => {});
    return code;
  }
  return getRef();
}

export function getRef() {
  return localStorage.getItem(KEY) || "";
}

export function clearRef() {
  localStorage.removeItem(KEY);
}
